import React, { useState, useCallback } from "react";

import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 as api } from "../../../../services/apis";

import { Container, Box, Header, FormBlock } from "./styles";


const RelatorioPacotesVendidos = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [relatorioCsv, setRelatorioCsv] = useState(false)

  const handleGenerateReport = useCallback(async () => {
    setLoading(true);
    setRelatorioCsv(false);

    const errorController = { error: false }

    await api.post("/admin/reports/pacotes-vendidos",
      {
        data_inicio: dataInicio,
        data_final: dataFinal,
      },
    )
      .then((res) => {
        setRelatorioCsv(res.data.url);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio entre ${dataInicio} e ${dataFinal}}`,
        });

        api.post("system_logs", { acao });
      })
      .catch((error) => {
        errorController.error = true

        if (!error.response) {
          return;
        };

        swal(`Algo deu errado na geração do relatório em Excel`, `Se persistir, contate nosso suporte`, "error");
      });


    setLoading(false);

    if (!errorController.error) {
      swal("Confirmado!", "Relatório gerado com sucesso", "success");
    };

  }, [dataInicio, dataFinal, swal]);



  return (
    <>
      <AdminMenu />
      <Container>
        <Header>Relatório Pacotes Vendidos</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loading}
              >
                Gerar Relatório
              </Button>
              <>
                {relatorioCsv && (
                  <Button
                    style={{ minWidth: "80px" }}
                    onClick={() => window.open(relatorioCsv, "_blank")}
                    color="green"
                  >
                    Baixar Relatório CSV
                  </Button>)
                }
              </>
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default RelatorioPacotesVendidos;
